import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { RegisterRequestDto } from "../generated/schema";

export function useRegister() {
  const mutation = $api.useMutation("post", "/auth/register");

  return useMutation({
    mutationFn: async (data: RegisterRequestDto) => {
      return mutation.mutateAsync({
        body: data,
        headers: {
          "x-auth-request": "true",
        },
      });
    },
  });
}
